import axios from 'axios'
import { env } from '../config/env'

const publicApi = axios.create({
  baseURL: env.api.url,
  timeout: env.api.timeout,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
})

export interface AppDocument {
  id: number
  type: string
  lang: string
  version: number
  content: string
  updated_at: string
}

class AppDocumentService {
  async getDocument(type: string, lang: string): Promise<{ success: boolean; document: AppDocument }> {
    const response = await publicApi.get(`v1/public/app-documents/${type}`, {
      params: { lang },
    })
    return response.data
  }
}

export default new AppDocumentService()
